module.exports = __webpack_public_path__ + "img/app.130054fd.jpg";